import { Component, AfterViewInit, Input, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from '@angular/core';

@Component({
	selector: 'added-user-group-item',
	templateUrl: 'added-user-group-item.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddedUserGroupItemComponent implements AfterViewInit ,OnDestroy{

	@Input('item') addedItem ;
	@Output('onSelectItem') onSelectItem: EventEmitter<any> = new EventEmitter();

	selectItem:boolean = true;

	private shouldDetectChanges = false
	constructor(
		private cdRef: ChangeDetectorRef
	) {
	 
	}

	ngAfterViewInit(){
		this.shouldDetectChanges = true;
		this.detectChanges();
	}

	ngOnDestroy() {
		this.shouldDetectChanges = false;
	}

	detectChanges() {
		if(this.shouldDetectChanges)
			this.cdRef.detectChanges();
	}

	select(selected) {
		this.onSelectItem.emit(this.addedItem);
	}

}



// WEBPACK FOOTER //
// ./src/components/added-user-group-item/added-user-group-item.ts